module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1012-13a56e1fe568fa6390a109332dee03c9.png";